var createGetParameterStringFromObject = function (parameterObject) {
    return Object.keys(parameterObject).reduce(function (totalString, currentKey, index) {
        if (index === 0)
            return currentKey + '=' + String(parameterObject[currentKey]);
        return totalString + '&' + currentKey + '=' + String(parameterObject[currentKey]);
    }, '');
};
var ObjectToGetParameterMapper = /** @class */ (function () {
    function ObjectToGetParameterMapper() {
    }
    ObjectToGetParameterMapper.map = function (parameterObject) {
        if (parameterObject === null) {
            return null;
        }
        return createGetParameterStringFromObject(parameterObject);
    };
    return ObjectToGetParameterMapper;
}());
export default ObjectToGetParameterMapper;
